import React from 'react';
import api from '@services/api';
import { Card } from 'antd';
import { IncorrectSummary } from '@services/types';
import { Link } from 'react-router-dom';
import { Navigation } from '@constants/Navigation';

const Incorrect = () => {
  const [incorrectSum, setIncorrectSum] = React.useState<IncorrectSummary>();

  React.useEffect(() => {
    api.reports.getDeviceReq().then((data) => {
      setIncorrectSum(data);
    });
  }, []);

  return (
    <Card
      bodyStyle={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '18px',
        fontWeight: '500',
      }}
      title="Incorrect requests"
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr max-content', gridGap: '20px' }}>
        <span>Today:</span>
        <Link to={Navigation.IncorrectRequests.replace(':period', '1D')}>{incorrectSum?.countWithinLast1D}</Link>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr max-content', gridGap: '20px' }}>
        <span>Today and Yesterday:</span>
        <Link to={Navigation.IncorrectRequests.replace(':period', '2D')}>{incorrectSum?.countWithinLast2D}</Link>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr max-content', gridGap: '20px' }}>
        <span>This month:</span>
        <Link to={Navigation.IncorrectRequests.replace(':period', '1M')}>{incorrectSum?.countWithinLast1M}</Link>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr max-content', gridGap: '20px' }}>
        <span>This month and last month:</span>
        <Link to={Navigation.IncorrectRequests.replace(':period', '2M')}>{incorrectSum?.countWithinLast2M}</Link>
      </div>
    </Card>
  );
};
export default React.memo(Incorrect);
